import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const ArrowLeft = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="arrow-left">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    className="fill-current"
                    d="M11.356 4.27586C11.7559 4.65675 11.7713 5.28973 11.3904 5.68966L6.33297 11L19.9996 11C20.5519 11 20.9996 11.4477 20.9996 12C20.9996 12.5523 20.5519 13 19.9996 13L6.33297 13L11.3904 18.3103C11.7713 18.7103 11.7559 19.3433 11.356 19.7241C10.956 20.105 10.323 20.0896 9.94216 19.6897L3.2755 12.6897C2.90768 12.3034 2.90768 11.6966 3.2755 11.3103L9.94216 4.31035C10.323 3.91042 10.956 3.89498 11.356 4.27586Z"
                />
            </g>
        </SvgIcon>
    );
};
